export const getDictPhrase = (dict, key) => {
    return dict[key] || key;
};
//# sourceMappingURL=getDictPhrase.js.map